import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const handleCookiePreferences = () => {
    // Remove consent to show banner again
    localStorage.removeItem('cookieConsent');
    // Reload page to show banner
    window.location.reload();
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>MarketVendr</h3>
          <p>Your trusted partner for logistics, distribution, and customs clearance solutions.</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/vendrs">Vendors</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            {process.env.REACT_APP_DASHBOARD_URL && (
              <li>
                <a href={`${process.env.REACT_APP_DASHBOARD_URL.replace(/\/$/, '')}/login`} target="_blank" rel="noopener noreferrer">Vendr Login</a>
              </li>
            )}
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li>Logistics</li>
            <li>Distribution</li>
            <li>Customs Clearance</li>
            <li>Label Compliance</li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <p>Tel: 01472 282216</p>
          <p>Email: <a href="mailto:Contact@marketvendr.com">Contact@marketvendr.com</a></p>
          <div className="footer-address">
            <p><strong>MarketVendr Offices:</strong></p>
            <p>53 Energy Parkway</p>
            <p>Grimsby</p>
            <p>DN31 2TT</p>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-company-info">
          <p><strong>MARKET VENDR LIMITED</strong></p>
          <p>AWRS NO: XQAW 000 0012 2069</p>
          <p>COMPANY REGISTRATION NO: 08047025</p>
          <p>VAT NO: 482 5075 80</p>
          <p>EORI: GB482507580000</p>
        </div>
        <div className="footer-legal">
          <p>&copy; {new Date().getFullYear()} MarketVendr. All rights reserved.</p>
          <button onClick={handleCookiePreferences} className="cookie-preferences-link">
            Cookie Preferences
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

